<template>
  <div class="dashboard-smart-insights" v-if="insights && insights.length > 0">
    <div class="insights-left">
      <v-icon color="#FF5722" small>mdi-lightbulb-on-outline</v-icon>
      <span class="insights-label">{{ $t('org-dashboard.smart-insights') }}</span>
    </div>
    <div class="insights-items">
      <div
        v-for="(insight, i) in insights"
        :key="i"
        class="insight-item"
      >
        <span
          class="insight-dot"
          :class="{'insight-dot--pulse': insight.pulse}"
          :style="{backgroundColor: insight.color || '#EF4444'}"
        ></span>
        <span class="insight-text">
          <span class="insight-value" :style="{color: insight.color || '#EF4444'}">{{ insight.value }}</span>
          {{ insight.label }}
        </span>
        <template v-if="insight.subLabel">
          <span class="insight-separator">|</span>
          <span class="insight-sub">{{ insight.subLabel }}</span>
        </template>
        <span v-if="i < insights.length - 1" class="insight-divider"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardSmartInsights',
  props: {
    insights: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss" scoped>
.dashboard-smart-insights {
  background: #263238;
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-left: 4px solid #FF5722;
  color: white;
  gap: 16px;
  flex-wrap: wrap;
}

.insights-left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.insights-label {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.insights-items {
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
}

.insight-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
}

.insight-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;

  &--pulse {
    animation: pulse 2s infinite;
  }
}

.insight-value {
  font-weight: 700;
}

.insight-separator {
  color: rgba(255, 255, 255, 0.3);
  margin: 0 2px;
}

.insight-sub {
  color: rgba(255, 255, 255, 0.6);
  font-size: 12px;
}

.insight-divider {
  width: 1px;
  height: 16px;
  background: rgba(255, 255, 255, 0.15);
  margin-left: 8px;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}
</style>
